import messages from './home.json' with { type: 'json' };

export const homeFi: Readonly<typeof messages> = messages;
